__turbopack_context__.v({
  "basic_button": "basic_button-module__-D-4NW__basic_button",
});
